// 사이드바 하단 "바로가기" 그룹 — ReengKi 패밀리 서비스 외부 링크.
// reengki.com/01 의 타일 중 어드민(본 LMS) 자신을 제외한 사이트 목록.
// 전부 새 탭으로 열리는 외부 링크이며 권한 구분 없이 모든 로그인 사용자에게 노출한다.

export interface Shortcut {
  name: string; // 표시 이름
  url: string; // 이동 대상 (새 탭)
  color: string; // 배지 배경색
  badge: string; // 배지 약칭 (1~2글자)
}

export const shortcuts: Shortcut[] = [
  { name: "통합 클래스 링키", url: "https://class.reengki.com/", color: "#3fb0e0", badge: "C" },
  { name: "CLASS ReengKi 2", url: "https://class2.reengki.com/", color: "#6cc26e", badge: "C2" },
  { name: "틴즈 LMS", url: "https://lms.talktree.io/reengki/login", color: "#f39c12", badge: "T" },
  { name: "CLASS TEENZ", url: "https://teenz.reengki.com/", color: "#6a4fb3", badge: "CT" },
  { name: "Reengki Academy", url: "https://academy.reengki.com/", color: "#e6c94a", badge: "RA" },
  { name: "ReengKi × ZZICGO", url: "https://ai.oneteacher.co.kr/zzicgo-contents/reengki", color: "#2fa3a8", badge: "Z" },
  { name: "진단 테스트", url: "https://test.reengki.com/", color: "#9aa5b1", badge: "D" },
];

export default shortcuts;
